import { render, staticRenderFns } from "./FormVirtualScoreDefinition.vue?vue&type=template&id=3514ad9c&"
import script from "./FormVirtualScoreDefinition.vue?vue&type=script&lang=js&"
export * from "./FormVirtualScoreDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports